module.exports = "<!-- <app-slider></app-slider> -->\n<div class=\"container-fluid\">\n  <app-slider></app-slider>\n\n  <app-prize></app-prize>\n</div>\n"